import { endpoints } from '../endpoints';
import { httpClient } from '../../lib/http-client';
import { exchangeRateSchema, type ExchangeRate } from '../../schemas/exchange-rate';

/**
 * Fetches the current exchange rate between GCS and ICS.
 */
export async function fetchExchangeRate(): Promise<ExchangeRate> {
  const { data } = await httpClient.get(endpoints.exchangeRate);
  // The mock server returns { rate: "..." } directly
  return exchangeRateSchema.parse(data);
}
